import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import AppBody from "../components/AppBody";
import DatePicker from "react-datepicker";
import { createTraining } from "../../actions/learning_provider/training_action";
import "react-datepicker/dist/react-datepicker.css";
import { Link, Navigate, useParams } from "react-router-dom";
import {
  getUserProfile,
  updateUserProfile,
} from "../../actions/learning_provider/user_profile_action";

const UpdateUserDetails = (fn) => {
  const [user, setUser] = useState({
    first_name: "",
    last_name: "",
    email: "",
    mobile_no: "",
    password: "",
    id: "",
    slug:"",
    is_set: false,
  });

  const dispatch = useDispatch();
  const state = useSelector((state) => state.userProfileReducer);
  let { slug } = useParams();

  useEffect(() => {
    dispatch(getUserProfile({ slug: slug }));
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(updateUserProfile(user));
  };

  if (!user.is_set && state.user.first_name) {
    setUser({
      first_name: state.user.first_name,
      last_name: state.user.last_name,
      email: state.user.email,
      mobile_no: state.user.mobile_no,
      password: state.user.password,
      id: state.user.id,
      slug:state.user.slug,
      is_set: true,
    });
  }

  if (state.is_done) {
    return <Navigate to="/users-list" />;
  }

  return (
    <AppBody
      loading={state.loading}
      content={
        <div className="middle-sidebar-left">
          <div className="">
            <div className="card">
              <div className="card-header p-3 w-100 border-0 d-flex rounded-lg">
                <Link
                  to={"/users-list"}
                  className="d-inline-block mt-2"
                ></Link>
                <h4 className="font-xs text-white fw-600  mb-0 mt-2">
                  Update User Profile
                </h4>
              </div>
              <div className="card-body w-100 border-0 ">
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-lg-6 mb-2">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          First Name
                        </label>
                        <input
                          placeholder="Enter First Name..."
                          type="text"
                          className="form-control"
                          value={user.first_name}
                          onChange={(e) =>
                            setUser({ ...user, first_name: e.target.value })
                          }
                        />
                        <span className="error-msg">
                          {state.errors ? state.errors.first_name : ""}
                        </span>
                      </div>
                    </div>
                    <div className="col-lg-6 mb-2">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Last Name
                        </label>
                        <input
                          placeholder="Enter Last Name..."
                          type="text"
                          className="form-control"
                          value={user.last_name}
                          onChange={(e) =>
                            setUser({ ...user, last_name: e.target.value })
                          }
                        />
                        <span className="error-msg">
                          {state.errors ? state.errors.last_name : ""}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-6 mb-2">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Email
                        </label>
                        <input
                          placeholder="Enter Email"
                          type="text"
                          className="form-control"
                          value={user.email}
                          onChange={(e) =>
                            setUser({ ...user, email: e.target.value })
                          }
                        />
                        <span className="error-msg">
                          {state.errors ? state.errors.email : ""}
                        </span>
                      </div>
                    </div>
                    <div className="col-lg-6 mb-2">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Mobile No
                        </label>
                        <input
                          placeholder="Enter Mobile No"
                          type="text"
                          className="form-control"
                          value={user.mobile_no}
                          onChange={(e) =>
                            setUser({ ...user, mobile_no: e.target.value })
                          }
                        />
                        <span className="error-msg">
                          {state.errors ? state.errors.mobile_no : ""}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-6 mb-2">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          New Password
                        </label>
                        <input
                          placeholder="Enter Paassword"
                          type="text"
                          className="form-control"
                           onChange={(e) =>
                            setUser({ ...user, password: e.target.value })
                          }
                        />
                        <span className="error-msg">
                          {state.errors ? state.errors.password : ""}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-12 my-3">
                      <input
                        type="submit"
                        name="submit"
                        value="Update"
                        className="btn-common px-5"
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default UpdateUserDetails;
